export const apiRoutes = {
    auth: {
        local: 'auth/local',
    },
    me: '/api/v2/users/me',
    users: '/api/v2/users',
    skills: '/api/v2/users/skills',
    removeApplicant: (jobId, stafferId) =>
        `/api/v3/jobs/${jobId}/staff/${stafferId}/remove`,
    replaceApplicant: (jobId, stafferId) =>
        `/api/v3/jobs/${jobId}/staff/${stafferId}/replace`,
    hireApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/hire`,
    rejectApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/reject`,
    holdApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/hold`,
    removeRecurringStaffer: (groupJobId, stafferId) =>
        `/api/v2/recurringShifts/${groupJobId}/staff/${stafferId}/remove`,
    replaceRecurringStaffer: (groupJobId, stafferId) =>
        `/api/v2/recurringShifts/${groupJobId}/staff/${stafferId}/replace`,
    hireRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/hire`,
    rejectRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/reject`,
    holdRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/hold`,
    deleteSingleJob: jobId => `/api/v3/jobs/single/${jobId}`,
    deleteMultiDayJob: jobId => `/api/v3/jobs/multi-day/${jobId}`,
    jobs: '/api/v3/jobs',
    singleRebroadcastShift: id => `/api/v3/jobs/${id}/rebroadcast`,
    recurringRebroadcastShift: id =>
        `/api/v2/recurringShifts/${id}/rebroadcast`,
    // updateJob: jobId => `/api/jobs/${jobId}`,
    jobLogs: jobId => `api/jobLog/fetchSpecificNonRecurringJobLog/${jobId}`,
    recurringJobsLogs: (groupJobId, jobId, pageNumber = 0, pageSize = 20) =>
        `api/jobLog/fetchSpecificRecurringJobLog/${groupJobId}?jobId=${jobId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    trackerLogs: jobId => `api/trackerLog/fetchSpecificJobLog/${jobId}`,
    smsLogs: 'api/jobs/smsLogs',
    createMultiDayJobs: '/api/v3/jobs/multi-day',
    createRecurringJobs: '/api/v3/jobs/recurring',
    updateJob: id => `/api/v3/jobs/single/${id}`,
    updateMultiDayJob: id => `/api/v3/jobs/multi-day/${id}`,
    updateRecurringJob: id => `/api/v3/jobs/multi-day/${id}`,
    entities: '/api/v2/entities',
    addNewShiftAddress: id => `/api/v2/entities/${id}/address`,
    teams: '/api/v2/teams',
    settings: '/api/v2/settings',
    searchUsers: '/api/users/searchAllStaffers/all',
    getStaffersToAddInUpcomingShift: shiftId =>
        `/api/jobs/getStaffersToAddInUpcomingShifts/${shiftId}`,
    searchEntities: '/api/v2/entities/search',
    uploadProfile: id => `/api/v2/users/${id}/upload/profileUrl`,
    getSkills: '/api/industries',
    skillsByJson: '/api/industries/getSkillsByJson',
    getSubSkills: '/api/industries/subSkill/list',
    blockUser: '/api/v2/block-list',
    addSkill: userId => `api/v2/users/${userId}/skills`,
    skill: skillId => `api/v2/users/skills/${skillId}`,
    subSkill: userId => `api/v2/users/${userId}/sub-skills`,
    addReference: userId => `/api/v2/users/${userId}/references`,
    updateReference: refId => `/api/v2/users/references/${refId}`,
    deleteReference: refId => `/api/v2/users/references/${refId}`,
    sendNotification: '/api/users/sendNotificationToUser/everyone',
    sendEmail: '/api/users/sendEmail/withText',
    sendSMS: userId => `/api/users/sendSMSToStaffer/${userId}`,
    addNote: userId => `/api/users/writeNote/${userId}`,
    availabilityLogs: userId =>
        `api/availabilityLog/fetchSpecificStafferLogs/${userId}`,
    relilabilityLogs: '/api/reliabilityScores/history',
    smsHistory: '/api/sms/twilioSMSHistory',
    receiveSMSHistory: '/api/sms/receiveTwilioSMSHistory',
    uploadResume: userId => `api/v2/users/${userId}/upload/resumeUrl`,
    sendResetPasswordEmail: 'api/appInfo/forgotPassword',
    uploadUniformPhoto: (id, type) => `/api/v2/users/${id}/upload/${type}`,
    updateUniformPhotoStatus: (id, type) =>
        `/api/v2/users/${id}/uniform-picture/${type}/update-status`,
    resetQuiz: userId => `/api/users/resetQuiz/${userId}`,
    acceptContractor: userId =>
        `/api/v2/users/${userId}/update-status/approve-profile`,
    rejectContractor: userId =>
        `/api/v2/users/${userId}/update-status/deactivate-profile`,
    blockContractor: userId => `/api/v2/users/${userId}/update-status/block`,
    putContractorUnderReview: userId =>
        `/api/v2/users/${userId}/update-status/under-review`,
    rejectedUser: '/api/rejected-user',
    restoreUser: userId => `/api/rejected-user/${userId}/restore`,
    restoreContractor: userId => `/api/users/markRestoreUser/${userId}`,
    userBlocklist: '/api/v2/block-list',
    removedFromUpcomingShifts: userId =>
        `api/jobs/admin/removeStafferFromUpcomingShifts/${userId}`,
    checkStafferAvailability: userId =>
        `/api/v2/users/${userId}/check-availability`,
    getUserAvailabilityForJob: userId =>
        `/api/v2/users/${userId}/job-availability`,
    clientBadgeList: '/api/physical-badge/badge-names',
    PriorityScoreLogs: userId =>
        `/api/v2/users/${userId}/misc-data/priority-score-logs`,
    deviceChangeRequests: {
        list: '/api/device-change-requests',
        approve: id => `/api/device-change-requests/${id}/approve`,
        reject: id => `/api/device-change-requests/${id}/reject`,
        history: userId => `/api/device-change-requests/user/${userId}/history`,
    },
    adminInvites: {
        send: '/api/admin-invites',
        list: '/api/admin-invites',
        resend: id => `/api/admin-invites/${id}/resend`,
        revoke: id => `/api/admin-invites/${id}/revoke`,
    },
    smsBlast: {
        getRecipientsAPI: province =>
            `/api/users/getSMSListToSpecificSkilledStaffers/admin/${province}${'/All/approved'}`,
        sendSMS: province =>
            `/api/users/sendSMSToSpecificSkilledStaffers/admin/${province}/${'All/approved'}`,
    },
    breakShiftByStaffers: jobId => `/api/jobs/breakShiftByStaffers/${jobId}`,
    breakRecurringShiftByStaffers:
        '/api/recurringShifts/breakRecurringShiftByStaffers/',
    // Tracker editing APIs
    createTracker: 'api/v2/tracker',
    updateTracker: trackerId => `api/v2/tracker/${trackerId}`,

    // Entity mutation routes (backend uses "entitys" not "entities" for writes)
    updateEntity: id => `/api/entitys/${id}`,
    customizeSkillRates: id => `/api/entitys/${id}/customizeSkillRates`,
    excludeSubSkills: id => `/api/entitys/${id}/excludeSubSkills`,
    entityUnitNumbers: id => `/api/entitys/${id}/unitNumber`,
    entityTasks: id => `/api/entitys/${id}/tasks`,
    entityTaskById: (entityId, taskId) =>
        `/api/entitys/${entityId}/tasks/${taskId}`,
    entityPatients: id => `/api/entitys/${id}/patient`,
    entityPatientById: (entityId, patientId) =>
        `/api/entitys/${entityId}/patient/${patientId}`,
    entityBulletins: id => `/api/entitys/${id}/update/bulletins`,

    // Schedule presets
    schedulePresets: '/api/schedule-presets',
    schedulePresetsBulk: '/api/schedule-presets/bulk',

    // Block list (company-centric)
    blockStafferFromCompany: userId => `/api/users/blockbyId/${userId}`,
    unblockStafferFromCompany: userId => `/api/users/userUnblock/${userId}`,

    // Unit persons (unit managers)
    unitPersons: entityId => `/api/unit/${entityId}/persons`,

    // User updates (for company creator)
    updateUser: userId => `/api/users/${userId}`,
    updateUserPicture: userId => `/api/v2/users/${userId}/upload/profileUrl`,
    secondaryLogins: userId => `/api/users/${userId}/secondary-logins`,

    // Soft delete
    markDeleteUser: userId => `/api/users/markDeleteUser/${userId}`,

    // Settings mutation routes
    updateSettings: '/api/settings/update',
    updateMessageOfDay: id => `/api/settings/send-message-of-the-day/${id}`,
    enableDisableOnboarding: '/api/settings/enableDisableOnboarding',
};
